// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file ticker_bot.proto (package cryptotrader, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { AccountId, ChannelId, TickerBotId } from "./ids_pb";
import { file_ids } from "./ids_pb";
import type { ProviderConfig } from "./configurable_pb";
import { file_configurable } from "./configurable_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file ticker_bot.proto.
 */
export const file_ticker_bot: GenFile = /*@__PURE__*/
  fileDesc("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", [file_ids, file_configurable, file_google_protobuf_timestamp]);

/**
 * @generated from message cryptotrader.TickerBotInput
 */
export type TickerBotInput = Message<"cryptotrader.TickerBotInput"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: cryptotrader.ProviderConfig market = 3;
   */
  market?: ProviderConfig | undefined;

  /**
   * @generated from field: repeated double tiers = 4;
   */
  tiers: number[];

  /**
   * @generated from field: double tier_band = 5;
   */
  tierBand: number;

  /**
   * @generated from field: double trailing_threshold = 6;
   */
  trailingThreshold: number;

  /**
   * @generated from field: double drop_threshold = 7;
   */
  dropThreshold: number;

  /**
   * @generated from field: bool enabled = 8;
   */
  enabled: boolean;
};

/**
 * Describes the message cryptotrader.TickerBotInput.
 * Use `create(TickerBotInputSchema)` to create a new message.
 */
export const TickerBotInputSchema: GenMessage<TickerBotInput> = /*@__PURE__*/
  messageDesc(file_ticker_bot, 0);

/**
 * @generated from message cryptotrader.TickerBot
 */
export type TickerBot = Message<"cryptotrader.TickerBot"> & {
  /**
   * @generated from field: cryptotrader.TickerBotId id = 1;
   */
  id?: TickerBotId | undefined;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: cryptotrader.TickerBotInput input = 3;
   */
  input?: TickerBotInput | undefined;

  /**
   * @generated from field: string status = 4;
   */
  status: string;

  /**
   * @generated from field: string status_msg = 5;
   */
  statusMsg: string;

  /**
   * @generated from field: repeated cryptotrader.TickerBotLink links = 6;
   */
  links: TickerBotLink[];

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */
  updatedAt?: Timestamp | undefined;
};

/**
 * Describes the message cryptotrader.TickerBot.
 * Use `create(TickerBotSchema)` to create a new message.
 */
export const TickerBotSchema: GenMessage<TickerBot> = /*@__PURE__*/
  messageDesc(file_ticker_bot, 1);

/**
 * @generated from message cryptotrader.UpsertTickerBotRequest
 */
export type UpsertTickerBotRequest = Message<"cryptotrader.UpsertTickerBotRequest"> & {
  /**
   * @generated from field: cryptotrader.TickerBotId id = 1;
   */
  id?: TickerBotId | undefined;

  /**
   * @generated from field: cryptotrader.TickerBotInput input = 2;
   */
  input?: TickerBotInput | undefined;
};

/**
 * Describes the message cryptotrader.UpsertTickerBotRequest.
 * Use `create(UpsertTickerBotRequestSchema)` to create a new message.
 */
export const UpsertTickerBotRequestSchema: GenMessage<UpsertTickerBotRequest> = /*@__PURE__*/
  messageDesc(file_ticker_bot, 2);

/**
 * @generated from message cryptotrader.TickerBotLink
 */
export type TickerBotLink = Message<"cryptotrader.TickerBotLink"> & {
  /**
   * @generated from field: cryptotrader.TickerBotId ticker_bot_id = 1;
   */
  tickerBotId?: TickerBotId | undefined;

  /**
   * @generated from field: cryptotrader.AccountId account_id = 2;
   */
  accountId?: AccountId | undefined;

  /**
   * @generated from field: cryptotrader.ChannelId channel_id = 3;
   */
  channelId?: ChannelId | undefined;

  /**
   * @generated from field: bool live_trading = 4;
   */
  liveTrading: boolean;

  /**
   * @generated from field: uint32 events = 5;
   */
  events: number;

  /**
   * @generated from field: string symbol_filter = 6;
   */
  symbolFilter: string;
};

/**
 * Describes the message cryptotrader.TickerBotLink.
 * Use `create(TickerBotLinkSchema)` to create a new message.
 */
export const TickerBotLinkSchema: GenMessage<TickerBotLink> = /*@__PURE__*/
  messageDesc(file_ticker_bot, 3);

/**
 * @generated from message cryptotrader.ListTickerBotsResponse
 */
export type ListTickerBotsResponse = Message<"cryptotrader.ListTickerBotsResponse"> & {
  /**
   * @generated from field: repeated cryptotrader.TickerBot ticker_bots = 1;
   */
  tickerBots: TickerBot[];
};

/**
 * Describes the message cryptotrader.ListTickerBotsResponse.
 * Use `create(ListTickerBotsResponseSchema)` to create a new message.
 */
export const ListTickerBotsResponseSchema: GenMessage<ListTickerBotsResponse> = /*@__PURE__*/
  messageDesc(file_ticker_bot, 4);

/**
 * @generated from message cryptotrader.TickerBotUpdate
 */
export type TickerBotUpdate = Message<"cryptotrader.TickerBotUpdate"> & {
  /**
   * @generated from oneof cryptotrader.TickerBotUpdate.payload
   */
  payload: {
    /**
     * @generated from field: cryptotrader.ListTickerBotsResponse snapshot = 1;
     */
    value: ListTickerBotsResponse;
    case: "snapshot";
  } | {
    /**
     * @generated from field: cryptotrader.TickerBot upserted = 2;
     */
    value: TickerBot;
    case: "upserted";
  } | {
    /**
     * @generated from field: cryptotrader.TickerBotId deleted = 3;
     */
    value: TickerBotId;
    case: "deleted";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message cryptotrader.TickerBotUpdate.
 * Use `create(TickerBotUpdateSchema)` to create a new message.
 */
export const TickerBotUpdateSchema: GenMessage<TickerBotUpdate> = /*@__PURE__*/
  messageDesc(file_ticker_bot, 5);

/**
 * @generated from message cryptotrader.TickerStateEntry
 */
export type TickerStateEntry = Message<"cryptotrader.TickerStateEntry"> & {
  /**
   * @generated from field: string symbol = 1;
   */
  symbol: string;

  /**
   * @generated from field: double change_pct = 2;
   */
  changePct: number;

  /**
   * @generated from field: double last_price = 3;
   */
  lastPrice: number;

  /**
   * @generated from field: int32 tier = 4;
   */
  tier: number;

  /**
   * @generated from field: bool following = 5;
   */
  following: boolean;

  /**
   * @generated from field: double highest_price = 6;
   */
  highestPrice: number;
};

/**
 * Describes the message cryptotrader.TickerStateEntry.
 * Use `create(TickerStateEntrySchema)` to create a new message.
 */
export const TickerStateEntrySchema: GenMessage<TickerStateEntry> = /*@__PURE__*/
  messageDesc(file_ticker_bot, 6);

/**
 * @generated from message cryptotrader.TickerStateSnapshot
 */
export type TickerStateSnapshot = Message<"cryptotrader.TickerStateSnapshot"> & {
  /**
   * @generated from field: repeated cryptotrader.TickerStateEntry entries = 1;
   */
  entries: TickerStateEntry[];
};

/**
 * Describes the message cryptotrader.TickerStateSnapshot.
 * Use `create(TickerStateSnapshotSchema)` to create a new message.
 */
export const TickerStateSnapshotSchema: GenMessage<TickerStateSnapshot> = /*@__PURE__*/
  messageDesc(file_ticker_bot, 7);

/**
 * @generated from message cryptotrader.TickerStateUpdate
 */
export type TickerStateUpdate = Message<"cryptotrader.TickerStateUpdate"> & {
  /**
   * @generated from oneof cryptotrader.TickerStateUpdate.payload
   */
  payload: {
    /**
     * @generated from field: cryptotrader.TickerStateSnapshot snapshot = 1;
     */
    value: TickerStateSnapshot;
    case: "snapshot";
  } | {
    /**
     * @generated from field: cryptotrader.TickerStateEntry upserted = 2;
     */
    value: TickerStateEntry;
    case: "upserted";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message cryptotrader.TickerStateUpdate.
 * Use `create(TickerStateUpdateSchema)` to create a new message.
 */
export const TickerStateUpdateSchema: GenMessage<TickerStateUpdate> = /*@__PURE__*/
  messageDesc(file_ticker_bot, 8);

